export const ADMINISTRATION_TABLE_PREFERENCES_PREFIX = "vendistri.administration.tables.";

export function clearAdministrationTablePreferences(storage: Storage) {
  try {
    const keys = Array.from({ length: storage.length }, (_, index) => storage.key(index))
      .filter((key): key is string => Boolean(key?.startsWith(ADMINISTRATION_TABLE_PREFERENCES_PREFIX)));
    keys.forEach((key) => storage.removeItem(key));
  } catch {
    // Ignore unavailable storage.
  }
}
